export default "/kiban/_next/static/images/1clickButtonHover-54782266d776002d62070ae4fd2359e3.png";